<template>
<div>
    <div class="row justify-content-center">
        <div class="col-md-12 col-lg-6 residentportal-default__column d-flex align-items-center justify-content-left">
            <div class="residentportal-default-left">
                <h2 class="residentportal-default-left__title">{{LandingPageContent.login_heading}}</h2>
                <div class="residentportal-default-left__content" v-html="LandingPageContent.login_content"></div>
                <button type="submit" class="btn btn-tru-green residentportal-default-left__btn" :style="'background-color:' + MainUISettings.main_site_button_color" @click="mainSiteLink()">{{ LandingPageContent.login_button_name || TEXTS.render(`LOGIN_MAIN_SITE_LINK`, null, null, {skipCasing : true}) }}</button>
            </div>
            <div v-if="MainUISettings.landing_page_image" class="residentportal-default-left__bg centered-bg-image" v-bind:style="'background: url('+ pubPath + MainUISettings.landing_page_image +'); box-shadow: rgba(0, 45, 81, 0.5) 0px 0px 0px 2000px inset'" ></div>
        </div>
        <div class="col-md-12 col-lg-6 residentportal-default__column d-flex align-items-center justify-content-center">
            <login-form></login-form>
        </div>
    </div>
    <!-- <main-header></main-header>
    <div class="residentportal-default">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-6 residentportal-default__column d-flex align-items-center">
                    <div class="residentportal-default-left">
                        <h2 class="residentportal-default-left__title">Lorem ipsum dolor sit amet</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent scelerisque rutrum est, vitae elementum turpis varius nec. Fusce viverra sem ut pulvinar fringilla.</p>
                        <button type="submit" class="btn btn-primary btn-tru-green residentportal-default-left__btn">Visit our website</button>
                    </div>
                    <div class="residentportal-default-left__bg" v-bind:style='{ background: "url(/img/seascape.jpg)", "box-shadow": "rgba(0, 45, 81, 0.5) 0px 0px 0px 2000px inset" }'></div>
                </div>
                <div class="col-md-12 col-lg-6 residentportal-default__column d-flex align-items-center"> -->
                <!-- </div>
            </div>
        </div>
    </div>
    <main-footer></main-footer> -->
</div>
</template>

<script>
    //import ExampleComponent from '../components/ExampleComponent';
    import LoginForm from './LoginForm';
    import Texts from '../../../../common/utils/Texts'
    // import MainHeader from '../components/Header';
    // import MainFooter from '../components/Footer';
    export default {
        data() {
            return {
                pubPath: process.env.MIX_APP_URL
            }
        },
        components: {
            LoginForm,
            // MainHeader,
            // MainFooter
        },
        methods: {
            mainSiteLink: function(){
                window.open(this.$store.getters.GET_LANDING_PAGE_CONTENT.login_button_link);
            }
        },
        computed: {
            TEXTS: () => Texts,
            MainUISettings() {
                return this.$store.getters['GET_MAIN_UI']; 
            },
            LandingPageContent() {
            return this.$store.getters['GET_LANDING_PAGE_CONTENT']; 
            }
        },
        mounted() {
            this.$store.dispatch('landingPageContent');
        }
    }
</script>
